
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as NextWithTextIconComponent } from "./next-with-text-icon.svg";

export const NextWithTextIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <NextWithTextIconComponent {...props} />;
};
